module.exports = __webpack_public_path__ + "static/media/27_B.a37bc457.png";